import { apiRequest } from '@/utils/api-request';
import * as Sentry from '@sentry/react';

interface RequestAccessResponse {
  data?: {
    id: string;
    status: string;
  };
  detail?: string;
}

/**
 * Request access to a workflow.
 */
export async function requestWorkflowAccess(
  orgId: string,
  workflowId: string,
  message?: string,
): Promise<RequestAccessResponse> {
  try {
    const response = await apiRequest<RequestAccessResponse>({
      url: `/api/v1/orgs/${orgId}/workflows/${workflowId}/request-access`,
      target: 'workflow',
      method: 'POST',
      body: {
        ...(message ? { message } : {}),
        requested_role: 'workflow:editor',
      },
    });

    return response as RequestAccessResponse;
  } catch (error) {
    Sentry.captureException(error, {
      extra: { context: 'request-workflow-access', workflowId },
    });
    throw error;
  }
}
